var map = {
	"./news1/image.png": "a787",
	"./news1/image1.jpg": "97b5",
	"./news1/image2.jpg": "db00",
	"./news1/image3.jpg": "eeff",
	"./news1/image4.jpg": "babf",
	"./news10/cover.jpg": "e5a5",
	"./news11/cover.png": "03a7",
	"./news11/scene4.png": "12b0",
	"./news11/scene5.png": "0b04",
	"./news12/cover.jpg": "58d2",
	"./news12/patent1.jpg": "4544",
	"./news12/patent2.jpg": "331d",
	"./news12/patent3.jpg": "4b2a",
	"./news13/cover.jpg": "4d9e",
	"./news13/image1.jpg": "3747",
	"./news13/image2.jpg": "254e",
	"./news2/image1.jpg": "8136",
	"./news2/image2.jpg": "b631",
	"./news2/image3.jpg": "e80c",
	"./news2/image4.jpg": "a040",
	"./news3/cover.jpg": "57f4",
	"./news3/image1.jpg": "60db",
	"./news3/image2.jpg": "90cf",
	"./news3/image3.jpg": "ac61",
	"./news3/image4.jpg": "aa54",
	"./news3/image5.jpg": "dca6",
	"./news3/image6.jpg": "3788",
	"./news3/image7.jpg": "3b1e",
	"./news4/cover.png": "5073",
	"./news4/image1.png": "d6ae",
	"./news4/image2.png": "509f",
	"./news4/image3.png": "e400",
	"./news4/image4.png": "e931",
	"./news5/cover.png": "54f9",
	"./news5/image1.jpg": "da03",
	"./news5/image2.jpg": "cf03",
	"./news5/image3.jpg": "15ae",
	"./news5/image4.jpg": "cdee",
	"./news5/image5.jpg": "f0a4",
	"./news6/cert.jpg": "b8ce",
	"./news6/cover.jpg": "cd50",
	"./news7/cover.jpg": "5964",
	"./news8/cover.jpg": "ec41",
	"./news8/image1.jpg": "52e0",
	"./news8/image2.jpg": "40aa",
	"./news8/image3.jpg": "26a5",
	"./news8/image4.jpg": "916d",
	"./news9/cover.jpg": "dde0",
	"./news9/image1.jpg": "38f9",
	"./news9/image2.jpg": "bc25",
	"./news9/image3.jpg": "cd56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea0f";